<template>
	<div
		class="mars-ape-sider"
		:class="{ 'mars-ape-sider-collapse': isCollapse }"
	>
		<div
			:class="[
				'sider-logo',
				this.$config.domain.ename == 'ganlanlv' ? 'sider-logo-gll' : '',
			]"
			:style="this.$config.domain.ename == 'zezhehui' ? 'padding-left:0px' : ''"
		>
			<a
				class="zzhClass"
				href="/"
				v-if="this.$config.domain.ename == 'zezhehui'"
			>
				<img style="width: 120px" :src="this.mxDomain.siderLogo" alt="" />
			</a>
			<a href="/" v-else>
				<img
					:src="this.mxDomain.siderLogo"
					:class="
						this.$config.domain.ename == 'ganlanlv' ? 'img img-big' : 'img'
					"
					alt=""
				/>
				<h1 v-if="this.$config.domain.ename !== 'shanqing'">
					{{
						this.$config.domain.ename == "ganlanlv" ? "" : this.mxDomain.title
					}}
				</h1>
			</a>
		</div>
		<el-menu
			v-if="isContract == 1"
			class="sider-menu"
			:default-active="routePath"
			:unique-opened="true"
			active-text-color="#FFFFFF"
			:collapse="isCollapse"
		>
			<li role="menuitem" aria-haspopup="true" class="el-submenu">
				<router-link to="/home">
					<div class="el-submenu__title" style="padding-left: 20px">
						<i
							class="iconfont iconyemian iconbtn"
							:class="[isCollapse ? 'is-collapse' : '']"
							style="color: #fff"
						></i
						><span v-if="!isCollapse">首页</span>
					</div>
				</router-link>
			</li>
			<li
				role="menuitem"
				aria-haspopup="true"
				class="el-submenu"
				v-if="this.$config.domain.is_show_ecology_page != 0"
			>
				<router-link to="/">
					<div class="el-submenu__title" style="padding-left: 20px">
						<i
							class="el-icon-monitor"
							style="color: #fff; margin-left: -4px"
						></i
						><span v-if="!isCollapse">生态产品</span>
					</div>
				</router-link>
			</li>
			<el-submenu
				v-for="(v, k) in menuList"
				:key="k"
				:index="v['id'].toString()"
			>
				<template slot="title">
					<i
						class="iconfont"
						style="color: #fff"
						:class="[v['icon'], isCollapse ? 'is-collapse' : '']"
					></i>
					<span>{{ v["display_name"] | formatName }}</span>
				</template>
				<div class="sider-menu-sub">
					<el-menu-item
						v-for="(v, k) in v['children']"
						:key="k"
						:index="v['url']"
						:class="{ 'menu-item-disabled': isPremiumRoute(v['url']) }"
						@click="handleMenuItemClick(v['url'], $event)"
					>
						<router-link v-if="!isPremiumRoute(v['url'])" :to="v['url']">{{
							v["display_name"]
						}}</router-link>
						<span v-else>{{ v["display_name"] }}</span>
					</el-menu-item>
				</div>
			</el-submenu>
		</el-menu>
	</div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
// eslint-disable-next-line no-unused-vars
let that;

export default {
	computed: {
		...mapState({
			userInfo: (state) => state.userInfo,
			isContract: (state) => state.isContract,
		}),
		...mapGetters(["isCollapse", "menuList", "routePath"]),
	},
	filters: {
		formatName: function(val) {
			if (that.$config.domain.ename === "yousuiyun") {
				switch (val) {
					case "个人中心":
						return "个人会员中心";
					case "操作中心":
						return "会员操作中心";
					default:
						return val;
				}
			} else {
				return val;
			}
		},
	},
	methods: {
		...mapMutations([
			"handleMenuList",
			"handleRoutePath",
			"handleUserPermissions",
		]),
		// 检查路由是否是增值服务
		isPremiumRoute(url) {
			if (!url) return false;

			// 付费路由数组
			const premiumRoutes = [
				"online_service",
				"agent_management",
				"share_reward",
				"store_management",
				"browsing_history",
				"resume_library",
			];

			// 规范化 URL，去掉开头的 / 和结尾的 /
			let normalizedUrl = url.replace(/^\/+|\/+$/g, "");

			// 检查是否在付费路由数组中
			return premiumRoutes.includes(normalizedUrl);
		},
		// 处理菜单项点击
		handleMenuItemClick(url, event) {
			if (this.isPremiumRoute(url)) {
				this.$message.warning(
					"当前功能为增值服务，如需使用，请联系管理员开通权限。"
				);
				event.preventDefault();
				event.stopPropagation();

				return false;
			}
		},
	},
	async created() {
		console.log(this.$config.domain.is_show_ecology_page != 0);
		that = this;
		let userMenuList = await this.$api.getUserMenuList();
		let userPermissionsList = await this.$api.getUserPermissionsList();
		this.handleMenuList(userMenuList["list"]);
		this.handleUserPermissions(userPermissionsList["list"]);
		if (Object.keys(this.$route.params).length != 0 && this.$route.matched[1]) {
			this.handleRoutePath(this.$route.matched[1].path);
		} else {
			this.handleRoutePath(this.$route.path);
		}
	},
};
</script>

<style lang="stylus">
.zzhClass {
  padding-top: 5px;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}

.mars-ape-sider:not(.mars-ape-sider-collapse) {
  /* flex 0 0 256px */
  width: 220px !important;
  transition: all 0.3s;
}

.mars-ape-sider-collapse, .el-menu--collapse {
  /* flex 0 0 80px */
  width: 80px !important;
  transition: all 0.3s;
}

/* 导航头部 */
.sider-logo {
  height: 64px;
  position: relative;
  line-height: 64px;
  padding-left: 24px;
  transition: all 0.3s;
  overflow: hidden;

  img {
    display: inline-block;
    vertical-align: middle;
    width: 32px;
  }

  .img-big {
    display: inline-block;
    vertical-align: middle;
    width: 80px;
    height: auto !important;
  }

  h1 {
    color: #fff;
    display: inline-block;
    vertical-align: middle;
    font-size: 20px;
    margin: 0 0 0 12px;
    font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
    font-weight: 600;
  }
}

.sider-logo-gll {
  padding-left: 0px !important;
  width: 100%;
  display: flex;
  background: #fff;
  justify-content: center;
}

/* 导航内容 */
.sider-menu {
  min-height: 100vh;
  width: auto !important;
  transition: all 0.3s;
}

.el-menu {
  border-right: solid 0px !important;
  list-style: none;
  position: relative;
  margin: 0;
  padding-left: 0;
  background-color: #2c343f;
}

.sider-menu-sub {
  // background #000c17
  // box-shadow inset 0 2px 8px rgba(0,0,0,.45)
}

.el-submenu a {
  text-decoration: none;
}

.el-submenu__title, .el-submenu__title {
  color: #FFFFFF;
}

.el-submenu__title {
  padding-left: 24px !important;
  padding-right: 34px;
  // margin-top 4px
  // margin-bottom 4px
  width: 100%;
  line-height: 50px;
  height: 50px;
}

.el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.el-menu-item {
  height: 40px;
  line-height: 40px;
  padding-left: 48px !important;
  padding-right: 16px;
  // margin-top 4px
  // margin-bottom 8px
  color: #b8bec3;

  a {
    color: #FFFFFF;
    text-decoration: none;
    display: block;
  }
}

.el-submenu [class^='iconfont'].is-collapse {
  padding-left: 8px;
  font-size: 16px;
}

.el-submenu [class^='iconfont']:not(.is-collapse) {
  vertical-align: middle;
  margin-right: 10px;
  display: inline-block;
  min-width: 14px;
  text-align: center;
  font-size: 14px;
}

.el-menu-item:focus {
  background-color: #2C343F;
}

.el-menu-item:hover {
  background-color: #232A32;
}

.el-menu-item:hover a, .el-menu-item:focus a {
  color: #ffffff;
}

.el-submenu__title:hover, .el-submenu__title:focus {
  background-color: #232A32;
  // color #ffffff
}

.el-submenu.is-opened .el-submenu__title, .el-submenu.is-opened .el-submenu__title>i, .el-submenu.is-active .el-submenu__title, .is-active>a, .el-submenu.is-active .el-submenu__title>i {
  color: #ffffff;
}

.el-menu-item.is-active>a {
  color: #FFD04B;
}

/* 禁用菜单项样式 */
.menu-item-disabled {
  opacity: 0.5;
  cursor: not-allowed !important;

  a, span {
    color: #6b7280 !important;
    pointer-events: none;
  }

  &:hover {
    background-color: #2C343F !important;

    a, span {
      color: #6b7280 !important;
    }
  }

  &:focus {
    background-color: #2C343F !important;

    a, span {
      color: #6b7280 !important;
    }
  }
}

/* 折叠后子菜单效果 */
.el-menu--vertical {
  left: 84px !important;
}

.el-menu--popup {
  border-radius: 4px;
  min-width: 160px;
}
</style>
